_ = require 'underscore'
BaseDirectoryView = require './base-directory-view'
DirectoryPluginItemView = require './directory-plugin-item-view'
t = require('views/internal/recup-with-helpers')('directory')
React = require 'react'

class DirectoryPageComponent extends React.Component
  displayName: 'Directory Page'

  render: t.renderable ->
    t.div '.directory-content-body', =>
      t.h2 =>
        t.format @props.title
      t.div '#directory-listing'

module.exports = class DirectoryCategoryView extends BaseDirectoryView
  renderContent: ->
    React.createElement DirectoryPageComponent, {
      title: @options.title
    }

  render: ->
    super
    contentContainer = @$el.find('#directory-listing')
    contentContainer.empty()

    { plugins, currentPage, directoryView } = @options

    pluginViews = _.map plugins, (plugin) =>
      @subview(DirectoryPluginItemView, @model, {
        atomType: 'description',
        currentPage,
        plugin,
        directoryView
      }, plugin.id)

    @appendSubviews(pluginViews, contentContainer)

    @



// WEBPACK FOOTER //
// ./app/scripts/views/directory/directory-page-view.coffee